import * as F from "react";
import Dt, { createContext as Ut, useState as Gt, useEffect as jt, useContext as kt } from "react";
const Ae = {
  BG: "bg",
  EN: "en",
  RU: "ru"
};
var de = { exports: {} }, ae = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function Vt() {
  if ($e) return ae;
  $e = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, a, o) {
    var i = null;
    if (o !== void 0 && (i = "" + o), a.key !== void 0 && (i = "" + a.key), "key" in a) {
      o = {};
      for (var s in a)
        s !== "key" && (o[s] = a[s]);
    } else o = a;
    return a = o.ref, {
      $$typeof: e,
      type: r,
      key: i,
      ref: a !== void 0 ? a : null,
      props: o
    };
  }
  return ae.Fragment = t, ae.jsx = n, ae.jsxs = n, ae;
}
var oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xe;
function $t() {
  return Xe || (Xe = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(l) {
      if (l == null) return null;
      if (typeof l == "function")
        return l.$$typeof === xe ? null : l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case P:
          return "Fragment";
        case O:
          return "Profiler";
        case A:
          return "StrictMode";
        case M:
          return "Suspense";
        case V:
          return "SuspenseList";
        case Te:
          return "Activity";
      }
      if (typeof l == "object")
        switch (typeof l.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), l.$$typeof) {
          case x:
            return "Portal";
          case I:
            return l.displayName || "Context";
          case b:
            return (l._context.displayName || "Context") + ".Consumer";
          case c:
            var E = l.render;
            return l = l.displayName, l || (l = E.displayName || E.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
          case le:
            return E = l.displayName || null, E !== null ? E : e(l.type) || "Memo";
          case J:
            E = l._payload, l = l._init;
            try {
              return e(l(E));
            } catch {
            }
        }
      return null;
    }
    function t(l) {
      return "" + l;
    }
    function n(l) {
      try {
        t(l);
        var E = !1;
      } catch {
        E = !0;
      }
      if (E) {
        E = console;
        var H = E.error, C = typeof Symbol == "function" && Symbol.toStringTag && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return H.call(
          E,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          C
        ), t(l);
      }
    }
    function r(l) {
      if (l === P) return "<>";
      if (typeof l == "object" && l !== null && l.$$typeof === J)
        return "<...>";
      try {
        var E = e(l);
        return E ? "<" + E + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var l = Q.A;
      return l === null ? null : l.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function i(l) {
      if (fe.call(l, "key")) {
        var E = Object.getOwnPropertyDescriptor(l, "key").get;
        if (E && E.isReactWarning) return !1;
      }
      return l.key !== void 0;
    }
    function s(l, E) {
      function H() {
        he || (he = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          E
        ));
      }
      H.isReactWarning = !0, Object.defineProperty(l, "key", {
        get: H,
        configurable: !0
      });
    }
    function u() {
      var l = e(this.type);
      return ce[l] || (ce[l] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), l = this.props.ref, l !== void 0 ? l : null;
    }
    function h(l, E, H, C, Z, re) {
      var L = H.ref;
      return l = {
        $$typeof: y,
        type: l,
        key: E,
        props: H,
        _owner: C
      }, (L !== void 0 ? L : null) !== null ? Object.defineProperty(l, "ref", {
        enumerable: !1,
        get: u
      }) : Object.defineProperty(l, "ref", { enumerable: !1, value: null }), l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(l, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(l, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Z
      }), Object.defineProperty(l, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: re
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    }
    function f(l, E, H, C, Z, re) {
      var L = E.children;
      if (L !== void 0)
        if (C)
          if (Se(L)) {
            for (C = 0; C < L.length; C++)
              v(L[C]);
            Object.freeze && Object.freeze(L);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else v(L);
      if (fe.call(E, "key")) {
        L = e(l);
        var $ = Object.keys(E).filter(function(_e) {
          return _e !== "key";
        });
        C = 0 < $.length ? "{key: someKey, " + $.join(": ..., ") + ": ...}" : "{key: someKey}", te[L + C] || ($ = 0 < $.length ? "{" + $.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          C,
          L,
          $,
          L
        ), te[L + C] = !0);
      }
      if (L = null, H !== void 0 && (n(H), L = "" + H), i(E) && (n(E.key), L = "" + E.key), "key" in E) {
        H = {};
        for (var ne in E)
          ne !== "key" && (H[ne] = E[ne]);
      } else H = E;
      return L && s(
        H,
        typeof l == "function" ? l.displayName || l.name || "Unknown" : l
      ), h(
        l,
        L,
        H,
        a(),
        Z,
        re
      );
    }
    function v(l) {
      d(l) ? l._store && (l._store.validated = 1) : typeof l == "object" && l !== null && l.$$typeof === J && (l._payload.status === "fulfilled" ? d(l._payload.value) && l._payload.value._store && (l._payload.value._store.validated = 1) : l._store && (l._store.validated = 1));
    }
    function d(l) {
      return typeof l == "object" && l !== null && l.$$typeof === y;
    }
    var g = Dt, y = Symbol.for("react.transitional.element"), x = Symbol.for("react.portal"), P = Symbol.for("react.fragment"), A = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), b = Symbol.for("react.consumer"), I = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), V = Symbol.for("react.suspense_list"), le = Symbol.for("react.memo"), J = Symbol.for("react.lazy"), Te = Symbol.for("react.activity"), xe = Symbol.for("react.client.reference"), Q = g.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fe = Object.prototype.hasOwnProperty, Se = Array.isArray, K = console.createTask ? console.createTask : function() {
      return null;
    };
    g = {
      react_stack_bottom_frame: function(l) {
        return l();
      }
    };
    var he, ce = {}, ee = g.react_stack_bottom_frame.bind(
      g,
      o
    )(), me = K(r(o)), te = {};
    oe.Fragment = P, oe.jsx = function(l, E, H) {
      var C = 1e4 > Q.recentlyCreatedOwnerStacks++;
      return f(
        l,
        E,
        H,
        !1,
        C ? Error("react-stack-top-frame") : ee,
        C ? K(r(l)) : me
      );
    }, oe.jsxs = function(l, E, H) {
      var C = 1e4 > Q.recentlyCreatedOwnerStacks++;
      return f(
        l,
        E,
        H,
        !0,
        C ? Error("react-stack-top-frame") : ee,
        C ? K(r(l)) : me
      );
    };
  })()), oe;
}
var Ye;
function Xt() {
  return Ye || (Ye = 1, process.env.NODE_ENV === "production" ? de.exports = Vt() : de.exports = $t()), de.exports;
}
var We = Xt(), Oe = function(e, t) {
  return Oe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, Oe(e, t);
};
function D(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Oe(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var m = function() {
  return m = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, m.apply(this, arguments);
};
function ye(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function j(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, o; r < a; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function U(e, t) {
  var n = t && t.cache ? t.cache : Qt, r = t && t.serializer ? t.serializer : qt, a = t && t.strategy ? t.strategy : Zt;
  return a(e, {
    cache: n,
    serializer: r
  });
}
function Yt(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function Wt(e, t, n, r) {
  var a = Yt(r) ? r : n(r), o = t.get(a);
  return typeof o > "u" && (o = e.call(this, r), t.set(a, o)), o;
}
function ht(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), a = n(r), o = t.get(a);
  return typeof o > "u" && (o = e.apply(this, r), t.set(a, o)), o;
}
function ct(e, t, n, r, a) {
  return n.bind(t, e, r, a);
}
function Zt(e, t) {
  var n = e.length === 1 ? Wt : ht;
  return ct(e, this, n, t.cache.create(), t.serializer);
}
function zt(e, t) {
  return ct(e, this, ht, t.cache.create(), t.serializer);
}
var qt = function() {
  return JSON.stringify(arguments);
}, Jt = (
  /** @class */
  (function() {
    function e() {
      this.cache = /* @__PURE__ */ Object.create(null);
    }
    return e.prototype.get = function(t) {
      return this.cache[t];
    }, e.prototype.set = function(t, n) {
      this.cache[t] = n;
    }, e;
  })()
), Qt = {
  create: function() {
    return new Jt();
  }
}, G = {
  variadic: zt
}, T;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(T || (T = {}));
var N;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(N || (N = {}));
var z;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(z || (z = {}));
function Ze(e) {
  return e.type === N.literal;
}
function Kt(e) {
  return e.type === N.argument;
}
function mt(e) {
  return e.type === N.number;
}
function vt(e) {
  return e.type === N.date;
}
function dt(e) {
  return e.type === N.time;
}
function pt(e) {
  return e.type === N.select;
}
function Et(e) {
  return e.type === N.plural;
}
function er(e) {
  return e.type === N.pound;
}
function gt(e) {
  return e.type === N.tag;
}
function bt(e) {
  return !!(e && typeof e == "object" && e.type === z.number);
}
function Ce(e) {
  return !!(e && typeof e == "object" && e.type === z.dateTime);
}
var yt = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, tr = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function rr(e) {
  var t = {};
  return e.replace(tr, function(n) {
    var r = n.length;
    switch (n[0]) {
      // Era
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      // Year
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      // Quarter
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      // Month
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      // Week
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      // Weekday
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      // Period
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      // am, pm, noon, midnight
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      // Hour
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      // Minute
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      // Second
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      // Zone
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      // 1..3, 4, 5: The ISO8601 varios formats
      case "O":
      // 1, 4: milliseconds in day short, long
      case "v":
      // 1, 4: generic non-location format
      case "V":
      // 1, 2, 3, 4: time zone ID or city
      case "X":
      // 1, 2, 3, 4: The ISO8601 varios formats
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var nr = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function ar(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(nr).filter(function(d) {
    return d.length > 0;
  }), n = [], r = 0, a = t; r < a.length; r++) {
    var o = a[r], i = o.split("/");
    if (i.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = i[0], u = i.slice(1), h = 0, f = u; h < f.length; h++) {
      var v = f[h];
      if (v.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: u });
  }
  return n;
}
function or(e) {
  return e.replace(/^(.*?)-/, "");
}
var ze = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Tt = /^(@+)?(\+|#+)?[rs]?$/g, ir = /(\*)(0+)|(#+)(0+)|(0+)/g, xt = /^(0+)$/;
function qe(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Tt, function(n, r, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : a === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function St(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function sr(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !xt.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Je(e) {
  var t = {}, n = St(e);
  return n || t;
}
function ur(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var a = r[n];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = or(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = m(m(m({}, t), { notation: "scientific" }), a.options.reduce(function(u, h) {
          return m(m({}, u), Je(h));
        }, {}));
        continue;
      case "engineering":
        t = m(m(m({}, t), { notation: "engineering" }), a.options.reduce(function(u, h) {
          return m(m({}, u), Je(h));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(ir, function(u, h, f, v, d, g) {
          if (h)
            t.minimumIntegerDigits = f.length;
          else {
            if (v && d)
              throw new Error("We currently do not support maximum integer digits");
            if (g)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (xt.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (ze.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(ze, function(u, h, f, v, d, g) {
        return f === "*" ? t.minimumFractionDigits = h.length : v && v[0] === "#" ? t.maximumFractionDigits = v.length : d && g ? (t.minimumFractionDigits = d.length, t.maximumFractionDigits = d.length + g.length) : (t.minimumFractionDigits = h.length, t.maximumFractionDigits = h.length), "";
      });
      var o = a.options[0];
      o === "w" ? t = m(m({}, t), { trailingZeroDisplay: "stripIfInteger" }) : o && (t = m(m({}, t), qe(o)));
      continue;
    }
    if (Tt.test(a.stem)) {
      t = m(m({}, t), qe(a.stem));
      continue;
    }
    var i = St(a.stem);
    i && (t = m(m({}, t), i));
    var s = sr(a.stem);
    s && (t = m(m({}, t), s));
  }
  return t;
}
var pe = {
  "001": [
    "H",
    "h"
  ],
  419: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CU: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function lr(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r);
    if (a === "j") {
      for (var o = 0; r + 1 < e.length && e.charAt(r + 1) === a; )
        o++, r++;
      var i = 1 + (o & 1), s = o < 2 ? 1 : 3 + (o >> 1), u = "a", h = fr(t);
      for ((h == "H" || h == "k") && (s = 0); s-- > 0; )
        n += u;
      for (; i-- > 0; )
        n = h + n;
    } else a === "J" ? n += "H" : n += a;
  }
  return n;
}
function fr(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var a = pe[r || ""] || pe[n || ""] || pe["".concat(n, "-001")] || pe["001"];
  return a[0];
}
var Pe, hr = new RegExp("^".concat(yt.source, "*")), cr = new RegExp("".concat(yt.source, "*$"));
function S(e, t) {
  return { start: e, end: t };
}
var mr = !!String.prototype.startsWith && "_a".startsWith("a", 1), vr = !!String.fromCodePoint, dr = !!Object.fromEntries, pr = !!String.prototype.codePointAt, Er = !!String.prototype.trimStart, gr = !!String.prototype.trimEnd, br = !!Number.isSafeInteger, yr = br ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, Le = !0;
try {
  var Tr = Rt("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Le = ((Pe = Tr.exec("a")) === null || Pe === void 0 ? void 0 : Pe[0]) === "a";
} catch {
  Le = !1;
}
var Qe = mr ? (
  // Native
  function(t, n, r) {
    return t.startsWith(n, r);
  }
) : (
  // For IE11
  function(t, n, r) {
    return t.slice(r, r + n.length) === n;
  }
), Me = vr ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = "", a = t.length, o = 0, i; a > o; ) {
      if (i = t[o++], i > 1114111)
        throw RangeError(i + " is not a valid code point");
      r += i < 65536 ? String.fromCharCode(i) : String.fromCharCode(((i -= 65536) >> 10) + 55296, i % 1024 + 56320);
    }
    return r;
  }
), Ke = (
  // native
  dr ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var n = {}, r = 0, a = t; r < a.length; r++) {
        var o = a[r], i = o[0], s = o[1];
        n[i] = s;
      }
      return n;
    }
  )
), _t = pr ? (
  // Native
  function(t, n) {
    return t.codePointAt(n);
  }
) : (
  // IE 11
  function(t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var a = t.charCodeAt(n), o;
      return a < 55296 || a > 56319 || n + 1 === r || (o = t.charCodeAt(n + 1)) < 56320 || o > 57343 ? a : (a - 55296 << 10) + (o - 56320) + 65536;
    }
  }
), xr = Er ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(hr, "");
  }
), Sr = gr ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(cr, "");
  }
);
function Rt(e, t) {
  return new RegExp(e, t);
}
var Be;
if (Le) {
  var et = Rt("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Be = function(t, n) {
    var r;
    et.lastIndex = n;
    var a = et.exec(t);
    return (r = a[1]) !== null && r !== void 0 ? r : "";
  };
} else
  Be = function(t, n) {
    for (var r = []; ; ) {
      var a = _t(t, n);
      if (a === void 0 || At(a) || Pr(a))
        break;
      r.push(a), n += a >= 65536 ? 2 : 1;
    }
    return Me.apply(void 0, r);
  };
var _r = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var a = []; !this.isEOF(); ) {
        var o = this.char();
        if (o === 123) {
          var i = this.parseArgument(t, r);
          if (i.err)
            return i;
          a.push(i.val);
        } else {
          if (o === 125 && t > 0)
            break;
          if (o === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), a.push({
              type: N.pound,
              location: S(s, this.clonePosition())
            });
          } else if (o === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(T.UNMATCHED_CLOSING_TAG, S(this.clonePosition(), this.clonePosition()));
          } else if (o === 60 && !this.ignoreTag && we(this.peek() || 0)) {
            var i = this.parseTag(t, n);
            if (i.err)
              return i;
            a.push(i.val);
          } else {
            var i = this.parseLiteral(t, n);
            if (i.err)
              return i;
            a.push(i.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: N.literal,
            value: "<".concat(a, "/>"),
            location: S(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var o = this.parseMessage(t + 1, n, !0);
        if (o.err)
          return o;
        var i = o.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !we(this.char()))
            return this.error(T.INVALID_TAG, S(s, this.clonePosition()));
          var u = this.clonePosition(), h = this.parseTagName();
          return a !== h ? this.error(T.UNMATCHED_CLOSING_TAG, S(u, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: N.tag,
              value: a,
              children: i,
              location: S(r, this.clonePosition())
            },
            err: null
          } : this.error(T.INVALID_TAG, S(s, this.clonePosition())));
        } else
          return this.error(T.UNCLOSED_TAG, S(r, this.clonePosition()));
      } else
        return this.error(T.INVALID_TAG, S(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Ar(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), a = ""; ; ) {
        var o = this.tryParseQuote(n);
        if (o) {
          a += o;
          continue;
        }
        var i = this.tryParseUnquoted(t, n);
        if (i) {
          a += i;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          a += s;
          continue;
        }
        break;
      }
      var u = S(r, this.clonePosition());
      return {
        val: { type: N.literal, value: a, location: u },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !Rr(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return Me.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), Me(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(T.EXPECT_ARGUMENT_CLOSING_BRACE, S(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(T.EMPTY_ARGUMENT, S(r, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(T.MALFORMED_ARGUMENT, S(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(T.EXPECT_ARGUMENT_CLOSING_BRACE, S(r, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: N.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: S(r, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(T.EXPECT_ARGUMENT_CLOSING_BRACE, S(r, this.clonePosition())) : this.parseArgumentOptions(t, n, a, r);
        default:
          return this.error(T.MALFORMED_ARGUMENT, S(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = Be(this.message, n), a = n + r.length;
      this.bumpTo(a);
      var o = this.clonePosition(), i = S(t, o);
      return { value: r, location: i };
    }, e.prototype.parseArgumentOptions = function(t, n, r, a) {
      var o, i = this.clonePosition(), s = this.parseIdentifierIfPossible().value, u = this.clonePosition();
      switch (s) {
        case "":
          return this.error(T.EXPECT_ARGUMENT_TYPE, S(i, u));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var h = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var f = this.clonePosition(), v = this.parseSimpleArgStyleIfPossible();
            if (v.err)
              return v;
            var d = Sr(v.val);
            if (d.length === 0)
              return this.error(T.EXPECT_ARGUMENT_STYLE, S(this.clonePosition(), this.clonePosition()));
            var g = S(f, this.clonePosition());
            h = { style: d, styleLocation: g };
          }
          var y = this.tryParseArgumentClose(a);
          if (y.err)
            return y;
          var x = S(a, this.clonePosition());
          if (h && Qe(h?.style, "::", 0)) {
            var P = xr(h.style.slice(2));
            if (s === "number") {
              var v = this.parseNumberSkeletonFromString(P, h.styleLocation);
              return v.err ? v : {
                val: { type: N.number, value: r, location: x, style: v.val },
                err: null
              };
            } else {
              if (P.length === 0)
                return this.error(T.EXPECT_DATE_TIME_SKELETON, x);
              var A = P;
              this.locale && (A = lr(P, this.locale));
              var d = {
                type: z.dateTime,
                pattern: A,
                location: h.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? rr(A) : {}
              }, O = s === "date" ? N.date : N.time;
              return {
                val: { type: O, value: r, location: x, style: d },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? N.number : s === "date" ? N.date : N.time,
              value: r,
              location: x,
              style: (o = h?.style) !== null && o !== void 0 ? o : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var b = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(T.EXPECT_SELECT_ARGUMENT_OPTIONS, S(b, m({}, b)));
          this.bumpSpace();
          var I = this.parseIdentifierIfPossible(), c = 0;
          if (s !== "select" && I.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(T.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, S(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var v = this.tryParseDecimalInteger(T.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, T.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (v.err)
              return v;
            this.bumpSpace(), I = this.parseIdentifierIfPossible(), c = v.val;
          }
          var M = this.tryParsePluralOrSelectOptions(t, s, n, I);
          if (M.err)
            return M;
          var y = this.tryParseArgumentClose(a);
          if (y.err)
            return y;
          var V = S(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: N.select,
              value: r,
              options: Ke(M.val),
              location: V
            },
            err: null
          } : {
            val: {
              type: N.plural,
              value: r,
              options: Ke(M.val),
              offset: c,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: V
            },
            err: null
          };
        }
        default:
          return this.error(T.INVALID_ARGUMENT_TYPE, S(i, u));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(T.EXPECT_ARGUMENT_CLOSING_BRACE, S(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(T.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, S(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = ar(t);
      } catch {
        return this.error(T.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: z.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? ur(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, a) {
      for (var o, i = !1, s = [], u = /* @__PURE__ */ new Set(), h = a.value, f = a.location; ; ) {
        if (h.length === 0) {
          var v = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var d = this.tryParseDecimalInteger(T.EXPECT_PLURAL_ARGUMENT_SELECTOR, T.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (d.err)
              return d;
            f = S(v, this.clonePosition()), h = this.message.slice(v.offset, this.offset());
          } else
            break;
        }
        if (u.has(h))
          return this.error(n === "select" ? T.DUPLICATE_SELECT_ARGUMENT_SELECTOR : T.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, f);
        h === "other" && (i = !0), this.bumpSpace();
        var g = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? T.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : T.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, S(this.clonePosition(), this.clonePosition()));
        var y = this.parseMessage(t + 1, n, r);
        if (y.err)
          return y;
        var x = this.tryParseArgumentClose(g);
        if (x.err)
          return x;
        s.push([
          h,
          {
            value: y.val,
            location: S(g, this.clonePosition())
          }
        ]), u.add(h), this.bumpSpace(), o = this.parseIdentifierIfPossible(), h = o.value, f = o.location;
      }
      return s.length === 0 ? this.error(n === "select" ? T.EXPECT_SELECT_ARGUMENT_SELECTOR : T.EXPECT_PLURAL_ARGUMENT_SELECTOR, S(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !i ? this.error(T.MISSING_OTHER_CLAUSE, S(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var o = !1, i = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          o = !0, i = i * 10 + (s - 48), this.bump();
        else
          break;
      }
      var u = S(a, this.clonePosition());
      return o ? (i *= r, yr(i) ? { val: i, err: null } : this.error(n, u)) : this.error(t, u);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = _t(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (Qe(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && At(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r ?? null;
    }, e;
  })()
);
function we(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function Rr(e) {
  return we(e) || e === 47;
}
function Ar(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function At(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Pr(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Fe(e) {
  e.forEach(function(t) {
    if (delete t.location, pt(t) || Et(t))
      for (var n in t.options)
        delete t.options[n].location, Fe(t.options[n].value);
    else mt(t) && bt(t.style) || (vt(t) || dt(t)) && Ce(t.style) ? delete t.style.location : gt(t) && Fe(t.children);
  });
}
function Ir(e, t) {
  t === void 0 && (t = {}), t = m({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new _r(e, t).parse();
  if (n.err) {
    var r = SyntaxError(T[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t?.captureLocation || Fe(n.val), n.val;
}
var k;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(k || (k = {}));
var X = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r, a) {
      var o = e.call(this, n) || this;
      return o.code = r, o.originalMessage = a, o;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  })(Error)
), tt = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r, a, o) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), k.INVALID_VALUE, o) || this;
    }
    return t;
  })(X)
), Nr = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r, a) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), k.INVALID_VALUE, a) || this;
    }
    return t;
  })(X)
), Hr = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), k.MISSING_VALUE, r) || this;
    }
    return t;
  })(X)
), B;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(B || (B = {}));
function Or(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== B.literal || n.type !== B.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function Pt(e) {
  return typeof e == "function";
}
function be(e, t, n, r, a, o, i) {
  if (e.length === 1 && Ze(e[0]))
    return [
      {
        type: B.literal,
        value: e[0].value
      }
    ];
  for (var s = [], u = 0, h = e; u < h.length; u++) {
    var f = h[u];
    if (Ze(f)) {
      s.push({
        type: B.literal,
        value: f.value
      });
      continue;
    }
    if (er(f)) {
      typeof o == "number" && s.push({
        type: B.literal,
        value: n.getNumberFormat(t).format(o)
      });
      continue;
    }
    var v = f.value;
    if (!(a && v in a))
      throw new Hr(v, i);
    var d = a[v];
    if (Kt(f)) {
      (!d || typeof d == "string" || typeof d == "number") && (d = typeof d == "string" || typeof d == "number" ? String(d) : ""), s.push({
        type: typeof d == "string" ? B.literal : B.object,
        value: d
      });
      continue;
    }
    if (vt(f)) {
      var g = typeof f.style == "string" ? r.date[f.style] : Ce(f.style) ? f.style.parsedOptions : void 0;
      s.push({
        type: B.literal,
        value: n.getDateTimeFormat(t, g).format(d)
      });
      continue;
    }
    if (dt(f)) {
      var g = typeof f.style == "string" ? r.time[f.style] : Ce(f.style) ? f.style.parsedOptions : r.time.medium;
      s.push({
        type: B.literal,
        value: n.getDateTimeFormat(t, g).format(d)
      });
      continue;
    }
    if (mt(f)) {
      var g = typeof f.style == "string" ? r.number[f.style] : bt(f.style) ? f.style.parsedOptions : void 0;
      g && g.scale && (d = d * (g.scale || 1)), s.push({
        type: B.literal,
        value: n.getNumberFormat(t, g).format(d)
      });
      continue;
    }
    if (gt(f)) {
      var y = f.children, x = f.value, P = a[x];
      if (!Pt(P))
        throw new Nr(x, "function", i);
      var A = be(y, t, n, r, a, o), O = P(A.map(function(c) {
        return c.value;
      }));
      Array.isArray(O) || (O = [O]), s.push.apply(s, O.map(function(c) {
        return {
          type: typeof c == "string" ? B.literal : B.object,
          value: c
        };
      }));
    }
    if (pt(f)) {
      var b = f.options[d] || f.options.other;
      if (!b)
        throw new tt(f.value, d, Object.keys(f.options), i);
      s.push.apply(s, be(b.value, t, n, r, a));
      continue;
    }
    if (Et(f)) {
      var b = f.options["=".concat(d)];
      if (!b) {
        if (!Intl.PluralRules)
          throw new X(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, k.MISSING_INTL_API, i);
        var I = n.getPluralRules(t, { type: f.pluralType }).select(d - (f.offset || 0));
        b = f.options[I] || f.options.other;
      }
      if (!b)
        throw new tt(f.value, d, Object.keys(f.options), i);
      s.push.apply(s, be(b.value, t, n, r, a, d - (f.offset || 0)));
      continue;
    }
  }
  return Or(s);
}
function Cr(e, t) {
  return t ? m(m(m({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = m(m({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function Lr(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = Cr(e[r], t[r]), n;
  }, m({}, e)) : e;
}
function Ie(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Mr(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: U(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, j([void 0], n, !1)))();
    }, {
      cache: Ie(e.number),
      strategy: G.variadic
    }),
    getDateTimeFormat: U(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, j([void 0], n, !1)))();
    }, {
      cache: Ie(e.dateTime),
      strategy: G.variadic
    }),
    getPluralRules: U(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, j([void 0], n, !1)))();
    }, {
      cache: Ie(e.pluralRules),
      strategy: G.variadic
    })
  };
}
var It = (
  /** @class */
  (function() {
    function e(t, n, r, a) {
      n === void 0 && (n = e.defaultLocale);
      var o = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(u) {
        var h = o.formatToParts(u);
        if (h.length === 1)
          return h[0].value;
        var f = h.reduce(function(v, d) {
          return !v.length || d.type !== B.literal || typeof v[v.length - 1] != "string" ? v.push(d.value) : v[v.length - 1] += d.value, v;
        }, []);
        return f.length <= 1 ? f[0] || "" : f;
      }, this.formatToParts = function(u) {
        return be(o.ast, o.locales, o.formatters, o.formats, u, void 0, o.message);
      }, this.resolvedOptions = function() {
        var u;
        return {
          locale: ((u = o.resolvedLocale) === null || u === void 0 ? void 0 : u.toString()) || Intl.NumberFormat.supportedLocalesOf(o.locales)[0]
        };
      }, this.getAst = function() {
        return o.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var i = a || {};
        i.formatters;
        var s = ye(i, ["formatters"]);
        this.ast = e.__parse(t, m(m({}, s), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Lr(e.formats, r), this.formatters = a && a.formatters || Mr(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = Ir, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  })()
), W;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(W || (W = {}));
var ie = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r, a) {
      var o = this, i = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return o = e.call(this, "[@formatjs/intl Error ".concat(n, "] ").concat(r, `
`).concat(i ? `
`.concat(i.message, `
`).concat(i.stack) : "")) || this, o.code = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(o, t), o;
    }
    return t;
  })(Error)
), Br = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r) {
      return e.call(this, W.UNSUPPORTED_FORMATTER, n, r) || this;
    }
    return t;
  })(ie)
), wr = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r) {
      return e.call(this, W.INVALID_CONFIG, n, r) || this;
    }
    return t;
  })(ie)
), rt = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r) {
      return e.call(this, W.MISSING_DATA, n, r) || this;
    }
    return t;
  })(ie)
), w = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r, a) {
      var o = e.call(this, W.FORMAT_ERROR, "".concat(n, `
Locale: `).concat(r, `
`), a) || this;
      return o.locale = r, o;
    }
    return t;
  })(ie)
), Ne = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r, a, o) {
      var i = e.call(this, "".concat(n, `
MessageID: `).concat(a?.id, `
Default Message: `).concat(a?.defaultMessage, `
Description: `).concat(a?.description, `
`), r, o) || this;
      return i.descriptor = a, i.locale = r, i;
    }
    return t;
  })(w)
), Fr = (
  /** @class */
  (function(e) {
    D(t, e);
    function t(n, r) {
      var a = e.call(this, W.MISSING_TRANSLATION, 'Missing message: "'.concat(n.id, '" for locale "').concat(r, '", using ').concat(n.defaultMessage ? "default message (".concat(typeof n.defaultMessage == "string" ? n.defaultMessage : n.defaultMessage.map(function(o) {
        var i;
        return (i = o.value) !== null && i !== void 0 ? i : JSON.stringify(o);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = n, a;
    }
    return t;
  })(ie)
);
function Dr(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
function q(e, t, n) {
  return n === void 0 && (n = {}), t.reduce(function(r, a) {
    return a in e ? r[a] = e[a] : a in n && (r[a] = n[a]), r;
  }, {});
}
var Ur = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, Gr = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, Nt = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Ur,
  onWarn: Gr
};
function Ht() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function Y(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function jr(e) {
  e === void 0 && (e = Ht());
  var t = Intl.RelativeTimeFormat, n = Intl.ListFormat, r = Intl.DisplayNames, a = U(function() {
    for (var s, u = [], h = 0; h < arguments.length; h++)
      u[h] = arguments[h];
    return new ((s = Intl.DateTimeFormat).bind.apply(s, j([void 0], u, !1)))();
  }, {
    cache: Y(e.dateTime),
    strategy: G.variadic
  }), o = U(function() {
    for (var s, u = [], h = 0; h < arguments.length; h++)
      u[h] = arguments[h];
    return new ((s = Intl.NumberFormat).bind.apply(s, j([void 0], u, !1)))();
  }, {
    cache: Y(e.number),
    strategy: G.variadic
  }), i = U(function() {
    for (var s, u = [], h = 0; h < arguments.length; h++)
      u[h] = arguments[h];
    return new ((s = Intl.PluralRules).bind.apply(s, j([void 0], u, !1)))();
  }, {
    cache: Y(e.pluralRules),
    strategy: G.variadic
  });
  return {
    getDateTimeFormat: a,
    getNumberFormat: o,
    getMessageFormat: U(function(s, u, h, f) {
      return new It(s, u, h, m({ formatters: {
        getNumberFormat: o,
        getDateTimeFormat: a,
        getPluralRules: i
      } }, f || {}));
    }, {
      cache: Y(e.message),
      strategy: G.variadic
    }),
    getRelativeTimeFormat: U(function() {
      for (var s = [], u = 0; u < arguments.length; u++)
        s[u] = arguments[u];
      return new (t.bind.apply(t, j([void 0], s, !1)))();
    }, {
      cache: Y(e.relativeTime),
      strategy: G.variadic
    }),
    getPluralRules: i,
    getListFormat: U(function() {
      for (var s = [], u = 0; u < arguments.length; u++)
        s[u] = arguments[u];
      return new (n.bind.apply(n, j([void 0], s, !1)))();
    }, {
      cache: Y(e.list),
      strategy: G.variadic
    }),
    getDisplayNames: U(function() {
      for (var s = [], u = 0; u < arguments.length; u++)
        s[u] = arguments[u];
      return new (r.bind.apply(r, j([void 0], s, !1)))();
    }, {
      cache: Y(e.displayNames),
      strategy: G.variadic
    })
  };
}
function je(e, t, n, r) {
  var a = e && e[t], o;
  if (a && (o = a[n]), o)
    return o;
  r(new Br("No ".concat(t, " format named: ").concat(n)));
}
function Ee(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = m({ timeZone: t }, e[r]), n;
  }, {});
}
function nt(e, t) {
  var n = Object.keys(m(m({}, e), t));
  return n.reduce(function(r, a) {
    return r[a] = m(m({}, e[a] || {}), t[a] || {}), r;
  }, {});
}
function at(e, t) {
  if (!t)
    return e;
  var n = It.formats;
  return m(m(m({}, n), e), { date: nt(Ee(n.date, t), Ee(e.date || {}, t)), time: nt(Ee(n.time, t), Ee(e.time || {}, t)) });
}
var De = function(e, t, n, r, a) {
  var o = e.locale, i = e.formats, s = e.messages, u = e.defaultLocale, h = e.defaultFormats, f = e.fallbackOnEmptyString, v = e.onError, d = e.timeZone, g = e.defaultRichTextElements;
  n === void 0 && (n = { id: "" });
  var y = n.id, x = n.defaultMessage;
  Dr(!!y, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var P = String(y), A = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    s && Object.prototype.hasOwnProperty.call(s, P) && s[P]
  );
  if (Array.isArray(A) && A.length === 1 && A[0].type === N.literal)
    return A[0].value;
  if (!r && A && typeof A == "string" && !g)
    return A.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (r = m(m({}, g), r || {}), i = at(i, d), h = at(h, d), !A) {
    if (f === !1 && A === "")
      return A;
    if ((!x || o && o.toLowerCase() !== u.toLowerCase()) && v(new Fr(n, o)), x)
      try {
        var O = t.getMessageFormat(x, u, h, a);
        return O.format(r);
      } catch (b) {
        return v(new Ne('Error formatting default message for: "'.concat(P, '", rendering default message verbatim'), o, n, b)), typeof x == "string" ? x : P;
      }
    return P;
  }
  try {
    var O = t.getMessageFormat(A, o, i, m({ formatters: t }, a || {}));
    return O.format(r);
  } catch (b) {
    v(new Ne('Error formatting message: "'.concat(P, '", using ').concat(x ? "default message" : "id", " as fallback."), o, n, b));
  }
  if (x)
    try {
      var O = t.getMessageFormat(x, u, h, a);
      return O.format(r);
    } catch (b) {
      v(new Ne('Error formatting the default message for: "'.concat(P, '", rendering message verbatim'), o, n, b));
    }
  return typeof A == "string" ? A : typeof x == "string" ? x : P;
}, kr = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function se(e, t, n, r) {
  var a = e.locale, o = e.formats, i = e.onError, s = e.timeZone;
  r === void 0 && (r = {});
  var u = r.format, h = m(m({}, s && { timeZone: s }), u && je(o, t, u, i)), f = q(r, kr, h);
  return t === "time" && !f.hour && !f.minute && !f.second && !f.timeStyle && !f.dateStyle && (f = m(m({}, f), { hour: "numeric", minute: "numeric" })), n(a, f);
}
function Vr(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], o = n[1], i = o === void 0 ? {} : o, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return se(e, "date", t, i).format(s);
  } catch (u) {
    e.onError(new w("Error formatting date.", e.locale, u));
  }
  return String(s);
}
function $r(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], o = n[1], i = o === void 0 ? {} : o, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return se(e, "time", t, i).format(s);
  } catch (u) {
    e.onError(new w("Error formatting time.", e.locale, u));
  }
  return String(s);
}
function Xr(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], o = n[1], i = n[2], s = i === void 0 ? {} : i, u = typeof a == "string" ? new Date(a || 0) : a, h = typeof o == "string" ? new Date(o || 0) : o;
  try {
    return se(e, "dateTimeRange", t, s).formatRange(u, h);
  } catch (f) {
    e.onError(new w("Error formatting date time range.", e.locale, f));
  }
  return String(u);
}
function Yr(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], o = n[1], i = o === void 0 ? {} : o, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return se(e, "date", t, i).formatToParts(s);
  } catch (u) {
    e.onError(new w("Error formatting date.", e.locale, u));
  }
  return [];
}
function Wr(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], o = n[1], i = o === void 0 ? {} : o, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return se(e, "time", t, i).formatToParts(s);
  } catch (u) {
    e.onError(new w("Error formatting time.", e.locale, u));
  }
  return [];
}
var Zr = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function zr(e, t, n, r) {
  var a = e.locale, o = e.onError, i = Intl.DisplayNames;
  i || o(new X(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, k.MISSING_INTL_API));
  var s = q(r, Zr);
  try {
    return t(a, s).of(n);
  } catch (u) {
    o(new w("Error formatting display name.", a, u));
  }
}
var qr = [
  "type",
  "style"
], ot = Date.now();
function Jr(e) {
  return "".concat(ot, "_").concat(e, "_").concat(ot);
}
function Qr(e, t, n, r) {
  r === void 0 && (r = {});
  var a = Ot(e, t, n, r).reduce(function(o, i) {
    var s = i.value;
    return typeof s != "string" ? o.push(s) : typeof o[o.length - 1] == "string" ? o[o.length - 1] += s : o.push(s), o;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function Ot(e, t, n, r) {
  var a = e.locale, o = e.onError;
  r === void 0 && (r = {});
  var i = Intl.ListFormat;
  i || o(new X(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, k.MISSING_INTL_API));
  var s = q(r, qr);
  try {
    var u = {}, h = n.map(function(f, v) {
      if (typeof f == "object") {
        var d = Jr(v);
        return u[d] = f, d;
      }
      return String(f);
    });
    return t(a, s).formatToParts(h).map(function(f) {
      return f.type === "literal" ? f : m(m({}, f), { value: u[f.value] || f.value });
    });
  } catch (f) {
    o(new w("Error formatting list.", a, f));
  }
  return n;
}
var Kr = ["type"];
function en(e, t, n, r) {
  var a = e.locale, o = e.onError;
  r === void 0 && (r = {}), Intl.PluralRules || o(new X(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, k.MISSING_INTL_API));
  var i = q(r, Kr);
  try {
    return t(a, i).select(n);
  } catch (s) {
    o(new w("Error formatting plural.", a, s));
  }
  return "other";
}
var tn = ["numeric", "style"];
function rn(e, t, n) {
  var r = e.locale, a = e.formats, o = e.onError;
  n === void 0 && (n = {});
  var i = n.format, s = !!i && je(a, "relative", i, o) || {}, u = q(n, tn, s);
  return t(r, u);
}
function nn(e, t, n, r, a) {
  a === void 0 && (a = {}), r || (r = "second");
  var o = Intl.RelativeTimeFormat;
  o || e.onError(new X(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, k.MISSING_INTL_API));
  try {
    return rn(e, t, a).format(n, r);
  } catch (i) {
    e.onError(new w("Error formatting relative time.", e.locale, i));
  }
  return String(n);
}
var an = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function Ct(e, t, n) {
  var r = e.locale, a = e.formats, o = e.onError;
  n === void 0 && (n = {});
  var i = n.format, s = i && je(a, "number", i, o) || {}, u = q(n, an, s);
  return t(r, u);
}
function on(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return Ct(e, t, r).format(n);
  } catch (a) {
    e.onError(new w("Error formatting number.", e.locale, a));
  }
  return String(n);
}
function sn(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return Ct(e, t, r).formatToParts(n);
  } catch (a) {
    e.onError(new w("Error formatting number.", e.locale, a));
  }
  return [];
}
function un(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function ln(e) {
  e.onWarn && e.defaultRichTextElements && un(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.github.io/docs/getting-started/message-distribution`);
}
function fn(e, t) {
  var n = jr(t), r = m(m({}, Nt), e), a = r.locale, o = r.defaultLocale, i = r.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && i ? i(new rt('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(o, '" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && i && i(new rt('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(o, '" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details'))) : (i && i(new wr('"locale" was not configured, using "'.concat(o, '" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details'))), r.locale = r.defaultLocale || "en"), ln(r), m(m({}, r), { formatters: n, formatNumber: on.bind(null, r, n.getNumberFormat), formatNumberToParts: sn.bind(null, r, n.getNumberFormat), formatRelativeTime: nn.bind(null, r, n.getRelativeTimeFormat), formatDate: Vr.bind(null, r, n.getDateTimeFormat), formatDateToParts: Yr.bind(null, r, n.getDateTimeFormat), formatTime: $r.bind(null, r, n.getDateTimeFormat), formatDateTimeRange: Xr.bind(null, r, n.getDateTimeFormat), formatTimeToParts: Wr.bind(null, r, n.getDateTimeFormat), formatPlural: en.bind(null, r, n.getPluralRules), formatMessage: De.bind(null, r, n), $t: De.bind(null, r, n), formatList: Qr.bind(null, r, n.getListFormat), formatListToParts: Ot.bind(null, r, n.getListFormat), formatDisplayName: zr.bind(null, r, n.getDisplayNames) });
}
function hn(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
function cn(e) {
  hn(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var mn = m(m({}, Nt), { textComponent: F.Fragment }), vn = { key: 42 }, dn = function(e) {
  return F.isValidElement(e) ? F.createElement(F.Fragment, vn, e) : e;
}, pn = function(e) {
  var t;
  return (t = F.Children.map(e, dn)) !== null && t !== void 0 ? t : [];
};
function En(e) {
  return function(t) {
    return e(F.Children.toArray(t));
  };
}
var ge = { exports: {} }, _ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var it;
function gn() {
  if (it) return _;
  it = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
  function b(c) {
    if (typeof c == "object" && c !== null) {
      var M = c.$$typeof;
      switch (M) {
        case t:
          switch (c = c.type, c) {
            case u:
            case h:
            case r:
            case o:
            case a:
            case v:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case s:
                case f:
                case y:
                case g:
                case i:
                  return c;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function I(c) {
    return b(c) === h;
  }
  return _.AsyncMode = u, _.ConcurrentMode = h, _.ContextConsumer = s, _.ContextProvider = i, _.Element = t, _.ForwardRef = f, _.Fragment = r, _.Lazy = y, _.Memo = g, _.Portal = n, _.Profiler = o, _.StrictMode = a, _.Suspense = v, _.isAsyncMode = function(c) {
    return I(c) || b(c) === u;
  }, _.isConcurrentMode = I, _.isContextConsumer = function(c) {
    return b(c) === s;
  }, _.isContextProvider = function(c) {
    return b(c) === i;
  }, _.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === t;
  }, _.isForwardRef = function(c) {
    return b(c) === f;
  }, _.isFragment = function(c) {
    return b(c) === r;
  }, _.isLazy = function(c) {
    return b(c) === y;
  }, _.isMemo = function(c) {
    return b(c) === g;
  }, _.isPortal = function(c) {
    return b(c) === n;
  }, _.isProfiler = function(c) {
    return b(c) === o;
  }, _.isStrictMode = function(c) {
    return b(c) === a;
  }, _.isSuspense = function(c) {
    return b(c) === v;
  }, _.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === r || c === h || c === o || c === a || c === v || c === d || typeof c == "object" && c !== null && (c.$$typeof === y || c.$$typeof === g || c.$$typeof === i || c.$$typeof === s || c.$$typeof === f || c.$$typeof === P || c.$$typeof === A || c.$$typeof === O || c.$$typeof === x);
  }, _.typeOf = b, _;
}
var R = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var st;
function bn() {
  return st || (st = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
    function b(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === r || p === h || p === o || p === a || p === v || p === d || typeof p == "object" && p !== null && (p.$$typeof === y || p.$$typeof === g || p.$$typeof === i || p.$$typeof === s || p.$$typeof === f || p.$$typeof === P || p.$$typeof === A || p.$$typeof === O || p.$$typeof === x);
    }
    function I(p) {
      if (typeof p == "object" && p !== null) {
        var Re = p.$$typeof;
        switch (Re) {
          case t:
            var ve = p.type;
            switch (ve) {
              case u:
              case h:
              case r:
              case o:
              case a:
              case v:
                return ve;
              default:
                var Ve = ve && ve.$$typeof;
                switch (Ve) {
                  case s:
                  case f:
                  case y:
                  case g:
                  case i:
                    return Ve;
                  default:
                    return Re;
                }
            }
          case n:
            return Re;
        }
      }
    }
    var c = u, M = h, V = s, le = i, J = t, Te = f, xe = r, Q = y, fe = g, Se = n, K = o, he = a, ce = v, ee = !1;
    function me(p) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), te(p) || I(p) === u;
    }
    function te(p) {
      return I(p) === h;
    }
    function l(p) {
      return I(p) === s;
    }
    function E(p) {
      return I(p) === i;
    }
    function H(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function C(p) {
      return I(p) === f;
    }
    function Z(p) {
      return I(p) === r;
    }
    function re(p) {
      return I(p) === y;
    }
    function L(p) {
      return I(p) === g;
    }
    function $(p) {
      return I(p) === n;
    }
    function ne(p) {
      return I(p) === o;
    }
    function _e(p) {
      return I(p) === a;
    }
    function Ft(p) {
      return I(p) === v;
    }
    R.AsyncMode = c, R.ConcurrentMode = M, R.ContextConsumer = V, R.ContextProvider = le, R.Element = J, R.ForwardRef = Te, R.Fragment = xe, R.Lazy = Q, R.Memo = fe, R.Portal = Se, R.Profiler = K, R.StrictMode = he, R.Suspense = ce, R.isAsyncMode = me, R.isConcurrentMode = te, R.isContextConsumer = l, R.isContextProvider = E, R.isElement = H, R.isForwardRef = C, R.isFragment = Z, R.isLazy = re, R.isMemo = L, R.isPortal = $, R.isProfiler = ne, R.isStrictMode = _e, R.isSuspense = Ft, R.isValidElementType = b, R.typeOf = I;
  })()), R;
}
var ut;
function yn() {
  return ut || (ut = 1, process.env.NODE_ENV === "production" ? ge.exports = gn() : ge.exports = bn()), ge.exports;
}
var He, lt;
function Tn() {
  if (lt) return He;
  lt = 1;
  var e = yn(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = r, o[e.Memo] = a;
  function i(y) {
    return e.isMemo(y) ? a : o[y.$$typeof] || t;
  }
  var s = Object.defineProperty, u = Object.getOwnPropertyNames, h = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, v = Object.getPrototypeOf, d = Object.prototype;
  function g(y, x, P) {
    if (typeof x != "string") {
      if (d) {
        var A = v(x);
        A && A !== d && g(y, A, P);
      }
      var O = u(x);
      h && (O = O.concat(h(x)));
      for (var b = i(y), I = i(x), c = 0; c < O.length; ++c) {
        var M = O[c];
        if (!n[M] && !(P && P[M]) && !(I && I[M]) && !(b && b[M])) {
          var V = f(x, M);
          try {
            s(y, M, V);
          } catch {
          }
        }
      }
    }
    return y;
  }
  return He = g, He;
}
Tn();
var ke = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = F.createContext(null)) : F.createContext(null);
ke.Consumer;
var xn = ke.Provider, Sn = xn, _n = ke;
function Lt() {
  var e = F.useContext(_n);
  return cn(e), e;
}
var Ue;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(Ue || (Ue = {}));
var Ge;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(Ge || (Ge = {}));
function Mt(e) {
  var t = function(n) {
    var r = Lt(), a = n.value, o = n.children, i = ye(n, ["value", "children"]), s = typeof a == "string" ? new Date(a || 0) : a, u = e === "formatDate" ? r.formatDateToParts(s, i) : r.formatTimeToParts(s, i);
    return o(u);
  };
  return t.displayName = Ge[e], t;
}
function ue(e) {
  var t = function(n) {
    var r = Lt(), a = n.value, o = n.children, i = ye(
      n,
      ["value", "children"]
    ), s = r[e](a, i);
    if (typeof o == "function")
      return o(s);
    var u = r.textComponent || F.Fragment;
    return F.createElement(u, null, s);
  };
  return t.displayName = Ue[e], t;
}
function Bt(e) {
  return e && Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    return t[n] = Pt(r) ? En(r) : r, t;
  }, {});
}
var ft = function(e, t, n, r) {
  for (var a = [], o = 4; o < arguments.length; o++)
    a[o - 4] = arguments[o];
  var i = Bt(r), s = De.apply(void 0, j([
    e,
    t,
    n,
    i
  ], a, !1));
  return Array.isArray(s) ? pn(s) : s;
}, Rn = function(e, t) {
  var n = e.defaultRichTextElements, r = ye(e, ["defaultRichTextElements"]), a = Bt(n), o = fn(m(m(m({}, mn), r), { defaultRichTextElements: a }), t), i = {
    locale: o.locale,
    timeZone: o.timeZone,
    fallbackOnEmptyString: o.fallbackOnEmptyString,
    formats: o.formats,
    defaultLocale: o.defaultLocale,
    defaultFormats: o.defaultFormats,
    messages: o.messages,
    onError: o.onError,
    defaultRichTextElements: a
  };
  return m(m({}, o), { formatMessage: ft.bind(null, i, o.formatters), $t: ft.bind(null, i, o.formatters) });
};
ue("formatDate");
ue("formatTime");
ue("formatNumber");
ue("formatList");
ue("formatDisplayName");
Mt("formatDate");
Mt("formatTime");
const wt = Ut({
  intl: void 0,
  lang: void 0,
  changeLang: () => {
  },
  translateMessage: () => ""
}), Pn = ({ messages: e, children: t }) => {
  const n = "lang", [r, a] = Gt(Ae.BG), o = Rn(
    {
      defaultLocale: Ae.BG,
      fallbackOnEmptyString: !0,
      locale: r,
      messages: e[r]
    },
    Ht()
  );
  jt(() => {
    const u = localStorage.getItem(n);
    u && Object.values(Ae).includes(u) && a(u);
  }, []);
  const i = (u) => {
    u !== r && (localStorage.setItem(n, u), a(u));
  }, s = (u) => {
    try {
      return o.formatMessage({ id: u });
    } catch (h) {
      return h;
    }
  };
  return /* @__PURE__ */ We.jsx(wt.Provider, { value: { intl: o, lang: r, changeLang: i, translateMessage: s }, children: /* @__PURE__ */ We.jsx(Sn, { value: o, children: t }) });
}, In = () => {
  const e = kt(wt);
  if (!e)
    throw new Error("useMyIntl must be used within a MyIntlProvider");
  return e;
};
export {
  Ae as LANGUAGES,
  Pn as MyIntlProvider,
  In as useMyIntl
};
